module.exports = __webpack_public_path__ + "static/img/updata-img.36d2f4db.png";